import { useState, useEffect, useCallback } from 'react';

const shopPhotos = [
  {
    src: 'https://storage.readdy-site.link/project_files/ce562620-5862-4120-a558-004b72aed42a/72b9f922-5ce3-4c6c-95af-b1acee3cf877_32024.png?v=ccf1e4a899f3df34c0e40e22f9633da9',
    alt: 'The Royal Collision Centre — workshop floor',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/ce562620-5862-4120-a558-004b72aed42a/4145e705-093c-477f-93c8-89c496e4c914_32026.png?v=3084afa98a4227714b40567f0fb0e831',
    alt: 'The Royal Collision Centre — precision repair',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/ce562620-5862-4120-a558-004b72aed42a/5cf9479f-e10e-4234-b292-46ca0ce7bd37_32034.png?v=6574d7d52c6e26bb872825ec4843b567',
    alt: 'The Royal Collision Centre — luxury detailing',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/ce562620-5862-4120-a558-004b72aed42a/2491a378-283f-4a9d-9e0f-9ba292a1005a_32035.png?v=c59845d3811340c08fde6b9507f179e9',
    alt: 'The Royal Collision Centre — premium facility',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/ce562620-5862-4120-a558-004b72aed42a/054117dc-55d6-44d4-98c7-ca6b70bd56c5_32062.png?v=57304be9238eae1e70c483732f39268a',
    alt: 'The Royal Collision Centre — expert technicians',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/ce562620-5862-4120-a558-004b72aed42a/715c178b-3dd7-48db-baa3-4b169fb2514a_32055.png?v=2669746145ac31fa72607dcd98df94d7',
    alt: 'The Royal Collision Centre — state of the art equipment',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/ce562620-5862-4120-a558-004b72aed42a/dcff8e16-3ec2-41bb-b355-e06a46fc9500_32001.png?v=6def73f681dc9e4727c5cad5f6adcb11',
    alt: 'The Royal Collision Centre — collision repair bay',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/ce562620-5862-4120-a558-004b72aed42a/34a611dd-f4de-4a09-8a39-c0efaa1f882e_32063.png?v=499988d29677b59768153703e161e266',
    alt: 'The Royal Collision Centre — paint and finish',
  },
];

export default function About() {
  const [current, setCurrent] = useState(0);
  const [transitioning, setTransitioning] = useState(false);

  const goTo = useCallback((index: number) => {
    if (transitioning) return;
    setTransitioning(true);
    setTimeout(() => {
      setCurrent(index);
      setTransitioning(false);
    }, 600);
  }, [transitioning]);

  useEffect(() => {
    const timer = setInterval(() => {
      goTo((current + 1) % shopPhotos.length);
    }, 4500);
    return () => clearInterval(timer);
  }, [current, goTo]);

  return (
    <section id="about" className="relative bg-[#060606] py-28 md:py-40 w-full overflow-hidden">
      {/* Logo watermark */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none overflow-hidden">
        <img
          src="https://storage.readdy-site.link/project_files/ce562620-5862-4120-a558-004b72aed42a/7446d410-13e5-4c24-8e98-4f7741eb6a7b_Captura-de-pantalla-2026-04-04-a-las-11.09.54-p.-m..png?v=5fc43223d84244d6c44dc34b1b28f18d"
          alt=""
          className="w-[600px] max-w-[70vw] object-contain"
          style={{
            opacity: 0.04,
            filter: 'blur(3px) grayscale(100%) brightness(2)',
          }}
        />
      </div>

      <div className="relative z-10 max-w-[1000px] mx-auto px-6 md:px-16">
        {/* Label */}
        <div className="text-center mb-16">
          <span className="text-yellow-600 text-xs tracking-[0.4em] uppercase font-light">Our Story</span>
          <div className="flex items-center justify-center gap-4 mt-4">
            <div className="h-px w-16 bg-gradient-to-r from-transparent to-yellow-600"></div>
            <div className="w-2 h-2 rounded-full bg-yellow-600"></div>
            <div className="h-px w-16 bg-gradient-to-l from-transparent to-yellow-600"></div>
          </div>
        </div>

        {/* Opening quote */}
        <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-white text-center leading-[1.3] mb-20">
          At The Royal Collision Centre,{' '}
          <span className="text-yellow-400 italic">recognition isn't chased</span>
          {' '}— it's earned.
        </h2>

        {/* Body paragraphs */}
        <div className="space-y-12">
          <p className="text-white/60 text-base md:text-lg leading-[2] font-light text-center md:text-left">
            Widely regarded as a pinnacle in luxury automotive repair, The Royal Collision Centre has been featured in national publications multiple times, including a{' '}
            <strong className="text-yellow-400 font-normal">SEMA showcase front cover</strong>. Its reputation is built on consistent performance, award-winning results, and a level of service that has led to exclusive partnerships with premier dealerships.
          </p>

          <div className="h-px bg-gradient-to-r from-transparent via-yellow-700/30 to-transparent"></div>

          <p className="text-white/60 text-base md:text-lg leading-[2] font-light text-center md:text-left">
            Behind it all is ownership rooted in real mastery — beginning as a leading BMW dealership painter at just 18 years old, now recognized on a{' '}
            <strong className="text-yellow-400 font-normal">global level</strong>{' '}
            for color accuracy and refinishing excellence.
          </p>

          <div className="h-px bg-gradient-to-r from-transparent via-yellow-700/30 to-transparent"></div>

          <p className="text-white/60 text-base md:text-lg leading-[2] font-light text-center md:text-left">
            Every technician operates under intense,{' '}
            <strong className="text-yellow-400 font-normal">factory-level training</strong>, delivering results that meet — and often exceed — OEM expectations. From advanced structural repairs to high-level refinishing, The Royal Collision Centre continues to raise the bar —{' '}
            <em className="text-white/80">repair by repair</em>{' '}
            — earning trust, respect, and recognition across the nation.
          </p>
        </div>

        {/* Signature line */}
        <div className="mt-20 flex flex-col items-center gap-4">
          <div className="h-px w-24 bg-yellow-600/50"></div>
          <span className="text-yellow-600/60 text-xs tracking-[0.4em] uppercase">The Royal Collision Centre</span>
          <span className="text-white/30 text-xs tracking-widest uppercase">Escondido, California</span>
        </div>

        {/* Elegant photo slideshow */}
        <div className="mt-20">
          {/* Main slide */}
          <div className="relative w-full h-[340px] md:h-[560px] rounded-2xl overflow-hidden bg-[#060606]">
            {shopPhotos.map((photo, i) => (
              <div
                key={i}
                className="absolute inset-0 transition-opacity duration-[900ms] ease-in-out flex items-center justify-center"
                style={{ opacity: i === current ? 1 : 0, zIndex: i === current ? 1 : 0 }}
              >
                <img
                  src={photo.src}
                  alt={photo.alt}
                  className="w-full h-full object-contain"
                  style={{
                    filter: 'brightness(0.97) contrast(1.03)',
                    transform: transitioning && i === current ? 'scale(1.02)' : 'scale(1)',
                    transition: 'transform 900ms ease-in-out',
                  }}
                />
                {/* Subtle dark vignette overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent pointer-events-none" />
              </div>
            ))}

            {/* Dot indicators */}
            <div className="absolute bottom-5 left-1/2 -translate-x-1/2 flex items-center gap-3 z-10">
              {shopPhotos.map((_, i) => (
                <button
                  key={i}
                  onClick={() => goTo(i)}
                  className="cursor-pointer transition-all duration-500"
                  style={{
                    width: i === current ? '28px' : '8px',
                    height: '4px',
                    borderRadius: '2px',
                    background: i === current ? '#ca8a04' : 'rgba(255,255,255,0.35)',
                  }}
                  aria-label={`Go to photo ${i + 1}`}
                />
              ))}
            </div>

            {/* Corner accent */}
            <div className="absolute top-4 right-4 z-10">
              <span className="text-yellow-600/50 text-[10px] tracking-[0.35em] uppercase font-light">
                {current + 1} / {shopPhotos.length}
              </span>
            </div>
          </div>

          {/* Thumbnail strip */}
          <div className="mt-4 grid grid-cols-4 gap-2 md:gap-3">
            {shopPhotos.map((photo, i) => (
              <button
                key={i}
                onClick={() => goTo(i)}
                className="cursor-pointer relative rounded-lg overflow-hidden h-16 md:h-20 transition-all duration-300"
                style={{
                  outline: i === current ? '1.5px solid #ca8a04' : '1.5px solid transparent',
                  opacity: i === current ? 1 : 0.45,
                }}
                aria-label={`View photo ${i + 1}`}
              >
                <img
                  src={photo.src}
                  alt={photo.alt}
                  className="w-full h-full object-cover object-center"
                />
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
